






























































import { Vue, Component } from 'vue-property-decorator';
import { FormModel } from 'ant-design-vue';
import { enumData, loading } from '@/decorators';
/** 弹框模式枚举 */
type ModalMode = 'add' | 'view' | 'edit' | 'copy';

@Component
export default class ProductModal extends Vue {
    /** 弹框可见状态 */
    private visible: boolean = false;

    /** 弹框模式：add-新增 | view-查看 | edit-编辑 */
    private mode: ModalMode = 'add';

    /** 当前操作的名称（商品名称等前缀信息） */
    private batchName: string = '';

    /** 提交加载状态 */
    private submitLoading: boolean = false;

    /** 表单数据 */
    private formData: TypeProductBatchAttribute.BatchRuleFormData = this.initFormData();

    /** 模式对应的标题文案 */
    private readonly modeTextMap: Record<ModalMode, string> = {
        add: this.t('新增'),
        view: this.t('查看'),
        edit: this.t('编辑'),
        copy: this.t('复制'),
    };
    // 商品状态
    @enumData('BoolStatusEnum')
    protected statusEnum: TypeBase.EnumListItem[] = [];
    // private statusEnum = [
    //     {
    //         text: this.t('启用'),
    //         value: 1,
    //     },
    //     {
    //         text: this.t('停用'),
    //         value: 0,
    //     },
    // ];
    /** 表单校验规则 */
    private get formDataRule(): Record<string, any> {
        return {
            enable_status: [
                { required: true, message: this.t('请选择状态'), trigger: 'change' },
            ],
            'batch_list.*.batch_length': [
                { required: true, message: this.t('请输入生产批次号总长度'), trigger: 'change' },
                {
                    trigger: 'change',
                    validator: (_rule: any, value: string, callback: Function) => {
                        if (!value && +value !== 0) return callback();
                        const positiveIntReg = /^[1-9]\d*$/;
                        if (!positiveIntReg.test(value)) {
                            return callback(new Error(this.t('请输入正整数')));
                        }
                        const num = Number(value);
                        if (num < 1 || num > 30) {
                            return callback(new Error(this.t('范围在1~30之间')));
                        }
                        const indexMatch = (_rule.field as string)?.match(/batch_list\.(\d+)\./);
                        const currentIndex = indexMatch ? Number(indexMatch[1]) : -1;
                        const currentRecord = this.formData.batch_list[currentIndex];
                        if (currentRecord) {
                            const isDuplicate = this.formData.batch_list.some((item, i) => {
                                if (i === currentIndex) return false;
                                return +item.batch_length === +value
                                    && (item.batch_prefix || '') === (currentRecord.batch_prefix || '')
                                    && (item.batch_suffix || '') === (currentRecord.batch_suffix || '');
                            });
                            if (isDuplicate) {
                                return callback(new Error(this.t('已存在重复数据，请检查')));
                            }
                        }
                        callback();
                    },
                },
            ],
        };
    }

    /**
     * 弹框标题，根据模式和名称动态生成
     */
    private get modalTitle(): string {
        return `${this.modeTextMap[this.mode]}${this.t('生产批次规则')}`;
    }

    /**
     * 是否为查看模式（只读）
     */
    private get isView(): boolean {
        return this.mode === 'view';
    }
    private get isAdd(): boolean {
        return this.mode === 'add';
    }
    /**
     * 表格列配置
     */
    private get columns(): TypeBase.TableColumn[] {
        const h = this.$createElement;
        return [
            {
                title: <span class="required-tag">{this.t('生产批次号总长度')}</span>,
                scopedSlots: { customRender: 'batch_length' },
            },
            {
                title: <span class="required-tag">{this.t('前缀')}</span>,
                scopedSlots: { customRender: 'batch_prefix' },
            },
            {
                title: <span class="required-tag">{this.t('后缀')}</span>,
                scopedSlots: { customRender: 'batch_suffix' },
            },
            {
                title: this.t('操作'),
                width: 80,
                scopedSlots: { customRender: 'operation' },
            },
        ];
    }

    /**
     * 初始化表单数据
     */
    private initFormData(): TypeProductBatchAttribute.BatchRuleFormData {
        return {
            enable_status: undefined,
            batch_list: [],
        };
    }

    /**
     * 创建一条空的批次行数据
     */
    private createBatchItem(): TypeProductBatchAttribute.BatchItem {
        return {
            _rowKey: `${Date.now()}_${Math.random()}`,
            id: undefined,
            batch_length: undefined,
            batch_prefix: '',
            batch_suffix: '',
        };
    }

    /**
     * 打开弹框
     * @param mode 弹框模式：add-新增 | view-查看 | edit-编辑
     * @param name 前缀名称（如商品名称）
     * @param data 回显数据（查看/编辑模式时传入）
     */
    public open(mode: ModalMode, data?: TypeProductBatchAttribute.BatchRuleListItem): void {
        this.mode = mode;
        this.formData = this.initFormData();
        if (data) {
            this.formData.batch_list = [
                {   
                    _rowKey: `${Date.now()}_${Math.random()}`,
                    id: mode === 'copy' ? undefined : data.id,
                    batch_length: data.batch_length,
                    batch_prefix: data.batch_prefix,
                    batch_suffix: data.batch_suffix,
                    enable_status: data.enable_status,
                    service_code: data.service_code || '',
                }
            ];
            this.formData.enable_status = data.enable_status;
        } else {
            this.handleAddRow();
        }
        this.visible = true;
        const formDataRef = this.$refs.formDataRef as FormModel;
        formDataRef && (formDataRef as any).clearValidate();
    }
    private handleBatchLengthChange(index: number, record: TypeProductBatchAttribute.BatchItem): void {
        const formDataRef = this.$refs.formDataRef as FormModel;
        this.$nextTick(() => {
            record.batch_prefix && (this.$refs.formDataRef as any).validateField(`batch_list.${index}.batch_prefix`);
            record.batch_suffix && (this.$refs.formDataRef as any).validateField(`batch_list.${index}.batch_suffix`);
        });
    }
    /**
     * 获取前缀字段的校验规则
     */
    private getPrefixRules(record: TypeProductBatchAttribute.BatchItem): any[] {
        return [
            {
                trigger: 'change',
                validator: (_rule: any, value: string, callback: Function) => {
                    if (!value && !record.batch_suffix) {
                        return callback(new Error(this.t('前缀或后缀其中必须一个有值')));
                    }
                    if (value && value.length > 30) {
                        return callback(new Error(this.t('长度不可超过30个字符')));
                    }
                    const totalLength = Number(record.batch_length);
                    const prefixLen = (value || '').length;
                    const suffixLen = (record.batch_suffix || '').length;
                    if (totalLength > 0 && (prefixLen + suffixLen) > totalLength) {
                        return callback(new Error(this.t('前缀和后缀的长度之和不可以大于生产批次号总长度')));
                    }
                    callback();
                },
            },
        ];
    }

    /**
     * 获取后缀字段的校验规则
     */
    private getSuffixRules(record: TypeProductBatchAttribute.BatchItem): any[] {
        return [
            {
                trigger: 'change',
                validator: (_rule: any, value: string, callback: Function) => {
                    if (!value && !record.batch_prefix) {
                        return callback(new Error(this.t('前缀或后缀其中必须一个有值')));
                    }
                    if (value && value.length > 30) {
                        return callback(new Error(this.t('长度不可超过30个字符')));
                    }
                    const totalLength = Number(record.batch_length);
                    const prefixLen = (record.batch_prefix || '').length;
                    const suffixLen = (value || '').length;
                    if (value && totalLength > 0 && (prefixLen + suffixLen) > totalLength) {
                        return callback(new Error(this.t('前缀和后缀的长度之和不可以大于生产批次号总长度')));
                    }
                    callback();
                },
            },
        ];
    }

    /**
     * 前缀/后缀变化时联动触发对方字段重新校验
     */
    private handlePrefixSuffixChange(index: number, field: 'batch_prefix' | 'batch_suffix'): void {
        const siblingField = field === 'batch_prefix' ? 'batch_suffix' : 'batch_prefix';
        this.$nextTick(() => {
            (this.$refs.formDataRef as any).validateField(`batch_list.${index}.${siblingField}`);
            (this.$refs.formDataRef as any).validateField(`batch_list.${index}.batch_length`);
        });
    }

    /**
     * 添加一行批次数据
     */
    private handleAddRow(): void {
        this.formData.batch_list.push(this.createBatchItem());
    }

    /**
     * 删除指定行批次数据
     * @param index 要删除的行索引
     */
    private handleRemoveRow(index: number): void {
        this.formData.batch_list.splice(index, 1);
        this.$nextTick(() => {
            this.formData.batch_list.forEach((_, i) => {
                (this.$refs.formDataRef as any).validateField(`batch_list.${i}.batch_length`);
            });
        });
    }

    /**
     * 全部删除批次数据
     */
    private handleDeleteAll(): void {
        this.$confirm({
            title: this.tc('温馨提示'),
            content: this.t('请确认是否全部删除'),
            onOk: () => {
                this.formData.batch_list = [this.createBatchItem()];
            },
        });
    }
    private getParams(): TypeProductBatchAttribute.BatchRulePostData {
        return {
            list: this.formData.batch_list.map((item) => ({
                ...item,
                _rowKey: undefined,
                enable_status: this.formData.enable_status || 0,
                service_code: '',
                batch_prefix: (item.batch_prefix || '').trim(),
                batch_suffix: (item.batch_suffix || '').trim(),
            })),
        };
    }
    private getUpdateParams(): TypeProductBatchAttribute.BatchItem {
        const row = this.formData.batch_list[0];
        return {
            ...row,
            _rowKey: undefined,
            enable_status: this.formData.enable_status || 0,
            batch_prefix: (row.batch_prefix || '').trim(),
            batch_suffix: (row.batch_suffix || '').trim(),
        };
    }
    /**
     * 提交表单
     */
    @loading('submitLoading')
    private handleSubmit(): void {
        const formRef = this.$refs.formDataRef as any;
        formRef.validate(async (valid: boolean) => {
            if (!valid) return;
            if (this.formData.batch_list.length === 0) {
                this.$message.error(this.t('请添加至少一条批次数据'));
                return;
            }
            try {
                this.$emit('submit', this.formData.batch_list);
                console.log('this.formData :>> ', this.formData);
                const data: TypeProductBatchAttribute.BatchRulePostData = this.getParams();
                if (this.mode === 'edit') {
                    const params = this.getUpdateParams();
                    await this.$api.batchAttribute.updateBatchRule(params);
                } else {
                    await this.$api.batchAttribute.saveBatchRule(data);
                }
                this.visible = false;
                this.$message.success(this.t('操作成功'));
                this.$emit('success', this.mode);
            } catch (error) {
                console.log('error :>> ', error);
            }
        });
    }
}
